import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import { AIAgentIcon } from '../../icons/AIAgentIcon';
import { CreateAIAgentOptions } from '../../models';

import styles from './AIAgentType.module.scss';

type AIAgentProps = {
  type: CreateAIAgentOptions;
  handleClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isSelected: boolean;
};

export const AIAgentType = ({ type, handleClick, isSelected }: AIAgentProps) => {
  const { t } = useTranslation();

  return (
    <button
      className={cn(styles.container, { [styles.selected]: isSelected })}
      onClick={handleClick}
    >
      <div className={styles.header}>
        <AIAgentIcon type={type} size={16} />

        <span className="text-sm leading-5 font-medium">{t(`ai_agents.types.${type}.title`)}</span>
      </div>
      <span className="text-sm leading-5 font-normal text-muted-foreground">
        {t(`ai_agents.types.${type}.description`)}
      </span>
    </button>
  );
};
